// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { PINTEREST } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const outboundClicksHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.outbound_clicks_history',
    tooltip: 'chart.pinterest.tooltip_outbound_clicks_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.pinterest.outbound_clicks_history_name',
        avg: 'chart.pinterest.outbound_clicks_history_avg'
    },
    id: 'outbound_clicks_history',
    social: PINTEREST,
    color: {
        value: 'blue',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.pinterest.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_FULL,
    type: 'chart',
    element: LineChart
};
